var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingListGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 19.3281C20.0391 19.5234 20.0391 19.7969 19.8438 19.9922L19.4531 20.3828C19.2578 20.5781 18.9844 20.5781 18.7891 20.3828L13.75 15.3438C13.6719 15.2656 13.6328 15.1484 13.6328 14.9922V14.6016C12.1875 15.9297 10.2344 16.75 8.125 16.75C3.63281 16.75 0 13.1172 0 8.625C0 4.17188 3.63281 0.5 8.125 0.5C12.5781 0.5 16.25 4.17188 16.25 8.625C16.25 10.7734 15.4297 12.6875 14.0625 14.1719H14.4922C14.6094 14.1719 14.7266 14.2109 14.8047 14.2891L19.8438 19.3281ZM8.125 15.5C11.9141 15.5 15 12.4531 15 8.625C15 4.83594 11.9141 1.75 8.125 1.75C4.29688 1.75 1.25 4.83594 1.25 8.625C1.25 12.4531 4.29688 15.5 8.125 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingListGrey);
export default __webpack_public_path__ + "static/media/shoppingListGrey.15e3c96d852ab96da6fa9c365730e54c.svg";
export { ForwardRef as ReactComponent };